import * as React from 'react';
import { getResourceString } from '../../kentico/resource-strings';

export interface PollResultsTotalProps {  
  pollResults: any;
}

export const PollResultsTotal = (props : PollResultsTotalProps) => {
  return props.pollResults &&
    <p className="form-poll__total-votes">{props.pollResults.TotalCount} {getResourceString("Form.PollResults.TotalCount")}</p>;
};